import React, { useEffect } from "react"

import { useScrollPosition } from "../../hooks/useScrollPosition"
import { useApp } from "../../hooks/useApp"
import { useCore } from "../../hooks/useCore"

export const withModalsPopup = Component => ({ name = "ModalsPopup", active, setActive, subscribe, onClose, ...props }) => {
  const { scrollHidden } = useScrollPosition()
  const {
    helpers: { storage },
  } = useCore()
  const {
    config: {
      settings: { keys },
    },
  } = useApp()

  useEffect(() => {
    scrollHidden(active)
  }, [active, scrollHidden])

  const handleClick = () => {
    setActive(false)
    if (subscribe) {
      storage.set(keys?.subscribe, "hidden")
    }
    if (onClose) {
      onClose()
    }
  }

  Component.displayName = name
  return <Component active={active} handleClick={handleClick} {...props} />
}
